export const sectorPriority = [
  {
    name: 'BAIXA',
    value: 'baixa'
  },
  {
    name: 'MÉDIA',
    value: 'media'
  },
  {
    name: 'ALTA',
    value: 'alta'
  },
  {
    name: 'MUITO ALTA',
    value: 'muito_alta'
  }
]

export const afastamentoType = [
  {
    name: 'NÃO INFORMADO',
    value: 'não informado'
  },
  {
    name: 'ATROPELAMENTO',
    value: 'atropelamento'
  },
  {
    name: 'COLISÃO',
    value: 'colisão'
  },
  {
    name: 'OUTROS',
    value: 'outros'
  }
]

export const types = [
  {
    name: 'EXTINTOR',
    value: 'extintor'
  },
  {
    name: 'HIDRANTE',
    value: 'hidrante'
  },
  {
    name: 'ILUMINAÇÃO',
    value: 'iluminacao'
  },
  {
    name: 'ACIONADORES E SIRENES',
    value: 'acionador_sirene'
  },
  {
    name: 'SISTEMA DE RESGATE',
    value: 'sis_resgate'
  }
]

export const maintenanceTypes = [
  {
    name: 'REPARO',
    value: 'reparo'
  },
  {
    name: 'PERIÓDICA',
    value: 'periódica'
  },
  {
    name: 'QUEBRA',
    value: 'quebra'
  },
  {
    name: 'SUBSTITUIÇÃO',
    value: 'substituição'
  },
  {
    name: 'PREVENTIVA',
    value: 'preventiva'
  },
  {
    name: 'CORRETIVA',
    value: 'corretiva'
  },
  {
    name: 'CORRETIVA PLANEJADA',
    value: 'corretiva planejada'
  },
  {
    name: 'CORRETIVA NÃO PLANEJADA',
    value: 'corretiva não planejada'
  },
  {
    name: 'MANUTENÇÃO DE PARADA',
    value: 'manutenção de parada'
  },
  {
    name: 'PREDITIVA',
    value: 'preditiva'
  },
  {
    name: 'PRODUTIVA TOTAL',
    value: 'produtiva total'
  }
]

export const hydrant = {
  estado_caixa: [
    {
      name: 'ADEQUADO',
      value: 'adequado'
    },
    {
      name: 'INADEQUADO',
      value: 'inadequado'
    },
    {
      name: 'NÃO APLICAVEL',
      value: 'nao'
    }
  ],
  bicos_e_keys: [
    {
      name: 'ADEQUADO',
      value: 'adequado'
    },
    {
      name: 'INADEQUADO',
      value: 'inadequado'
    },
    {
      name: 'NÃO APLICAVEL',
      value: 'nao'
    }
  ],
  sinalizacao: [
    {
      name: 'ADEQUADO',
      value: 'adequado'
    },
    {
      name: 'INADEQUADO',
      value: 'inadequado'
    },
    {
      name: 'NÃO APLICAVEL',
      value: 'nao'
    }
  ]
}

export const light = {
  estado_caixa: [
    {
      name: 'ADEQUADO',
      value: 'adequado'
    },
    {
      name: 'INADEQUADO',
      value: 'inadequado'
    },
    {
      name: 'NÃO APLICAVEL',
      value: 'nao'
    }
  ],
  obstru: [
    {
      name: 'SIM',
      value: 'sim'
    },
    {
      name: 'NÃO',
      value: 'nao'
    }
  ],
  tom_energia: [
    {
      name: 'ADEQUADO',
      value: 'adequado'
    },
    {
      name: 'INADEQUADO',
      value: 'inadequado'
    },
    {
      name: 'NÃO APLICAVEL',
      value: 'nao'
    }
  ],
  funcionamento: [
    {
      name: 'ADEQUADO',
      value: 'adequado'
    },
    {
      name: 'INADEQUADO',
      value: 'inadequado'
    },
    {
      name: 'NÃO APLICAVEL',
      value: 'nao'
    }
  ],
  ilum_type: [
    {
      name: 'ACLARAMENTO',
      value: 'aclaramento'
    },
    {
      name: 'BALIZAMENTO',
      value: 'balizamento'
    }
  ]
}

export const siren = {
  estado_caixa: [
    {
      name: 'ADEQUADO',
      value: 'adequado'
    },
    {
      name: 'INADEQUADO',
      value: 'inadequado'
    },
    {
      name: 'NÃO APLICAVEL',
      value: 'nao'
    }
  ],
  obstru: [
    {
      name: 'SIM',
      value: 'sim'
    },
    {
      name: 'NÃO',
      value: 'nao'
    }
  ],
  leds: [
    {
      name: 'ADEQUADO',
      value: 'adequado'
    },
    {
      name: 'INADEQUADO',
      value: 'inadequado'
    },
    {
      name: 'NÃO APLICAVEL',
      value: 'nao'
    }
  ],
  comunicacao: [
    {
      name: 'ADEQUADO',
      value: 'adequado'
    },
    {
      name: 'INADEQUADO',
      value: 'inadequado'
    },
    {
      name: 'NÃO APLICAVEL',
      value: 'nao'
    }
  ],
  funcionamento: [
    {
      name: 'ADEQUADO',
      value: 'adequado'
    },
    {
      name: 'INADEQUADO',
      value: 'inadequado'
    },
    {
      name: 'NÃO APLICAVEL',
      value: 'nao'
    }
  ]
}

export const extinguisher = {
  category: [
    {
      name: 'PORTÁTIL',
      value: 'portatil'
    },
    {
      name: 'CARRETA',
      value: 'carreta'
    },
    {
      name: 'OUTROS',
      value: 'outros'
    }
  ],
  type: [
    {
      name: 'ÁGUA',
      value: 'agua'
    },
    {
      name: 'CO²',
      value: 'co2'
    },
    {
      name: '(PQS) BC',
      value: 'bc'
    },
    {
      name: '(PQS) ABC',
      value: 'abc'
    },
    {
      name: 'ESPUMA',
      value: 'espuma'
    }
  ],
  condicao: [
    {
      name: 'ADEQUADO',
      value: 'adequado'
    },
    {
      name: 'INADEQUADO',
      value: 'inadequado'
    },
    {
      name: 'NÃO APLICAVEL',
      value: 'nao'
    }
  ],
  manometros: [
    {
      name: 'ADEQUADO',
      value: 'adequado'
    },
    {
      name: 'INADEQUADO',
      value: 'inadequado'
    },
    {
      name: 'NÃO APLICAVEL',
      value: 'nao'
    }
  ],
  sinalizacao: [
    {
      name: 'ADEQUADO',
      value: 'adequado'
    },
    {
      name: 'INADEQUADO',
      value: 'inadequado'
    },
    {
      name: 'NÃO APLICAVEL',
      value: 'nao'
    }
  ],
  obstru: [
    {
      name: 'SIM',
      value: 'sim'
    },
    {
      name: 'NÃO',
      value: 'nao'
    }
  ]
}

export const sis_resgate = {
  condicao: [
    {
      name: 'ADEQUADO',
      value: 'adequado'
    },
    {
      name: 'INADEQUADO',
      value: 'inadequado'
    },
    {
      name: 'NÃO APLICAVEL',
      value: 'nao'
    }
  ]
}

export const yesOrNo = [
  {
    name: 'SIM',
    value: true
  },
  {
    name: 'NÃO',
    value: false
  }
]

// provisório - perguntas
export const modules = [
  {
    name: 'NR 11',
    value: 1
  },
  {
    name: 'NR 06',
    value: 2
  }
]
export const question = [
  {
    name: 'NR 11 - AULA 1 INTRODUÇÃO A EMPILHADEIRA',
    value: 1
  },
  {
    name: 'NR 06 - AULA 13 DIFERENÇA ENTRE EPI E EPC',
    value: 2
  }
]

export default {
  sectorPriority,
  types,
  afastamentoType,
  extinguisher,
  hydrant,
  maintenanceTypes,
  yesOrNo,
  modules,
  question
}
